module.exports = __webpack_public_path__ + "img/image.286e37aa.svg";